import React from 'react';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import BoardsApp from '@atlassian/jira-boards-page/src/view/index.tsx';
import { ErrorFlagRenderer } from '@atlassian/jira-error-boundary-flag-renderer/src/ErrorBoundaryFlag.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import {
	appBundleReadyMark,
	prefetchApiReadyMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { BoardsDirectorySkeleton } from '@atlassian/jira-skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import { boardsDirectoryPageLoad } from '../utils/performance-analytics/index.tsx';
import type { Props } from './types.tsx';

// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

function BoardsDirectory(props: Props): React.JSX.Element {
	const { Updater, tenantContext, prefetchResult, favoriteChangeContext, query, onQueryChanged } =
		props;

	const { locale, xsrfToken, atlassianAccountId } = tenantContext;
	const { error: prefetchError, loading, data } = prefetchResult;

	if (prefetchError && !loading) {
		// @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
		return <ErrorFlagRenderer id="directories-boards" error={prefetchError} />;
	}

	if (!data) {
		return <BoardsDirectorySkeleton />;
	}

	return (
		<PageLayout>
			<ReportErrors id="unhandled" packageName="jiraSpaAppsDirectoriesBoards" teamName="keystone">
				<Updater />
				<BoardsApp
					isServer={__SERVER__}
					accountId={atlassianAccountId || null}
					locale={locale}
					xsrfToken={xsrfToken}
					query={query}
					favoriteChangeContext={favoriteChangeContext}
					prefetchedData={data}
					onQueryChanged={onQueryChanged}
					onUnmount={noop}
					withPageReadyMetrics={false}
				/>
				{/* @ts-expect-error - TS2769 - No overload matches this call. */}
				<SubmitApdex
					metricKey="jira.directories.boards"
					metric={boardsDirectoryPageLoad}
					isExpectedToHaveSsr
					withMarks={[appBundleReadyMark, prefetchApiReadyMark]}
				/>
			</ReportErrors>
		</PageLayout>
	);
}

export default AnalyticsSource('boards', SCREEN)(BoardsDirectory);
